















































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'ScannerResourceList'
  components: {
    Modal,
    Trigger,
    ResourceList,
    LoadingIndicator
  }

  vue:
    props: ['scanners', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']

    data: ->
      pageNumber: 1
      selectedScanners: []
      selectedFilters: []

      filters:
        q: ''

      deleteModal:
        modalOptions:
          title: 'Delete Scanner'
          button:
            label: 'Delete'
            type: 'danger'

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?

    computed:
      components: ->
        {
          'scanner-resource-list-item': () => import('./ScannerResourceListItem')
        }
      title: ->
        @options?.title || 'Scanners'

      resourceKey: ->
        @options?.resourceKey || 'scanners'

      verifiedBadgeSrc: -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_verified_badge.png"

      deleteTriggerResource: ->
        { key: @resourceKey, triggerName: 'delete', component: @$parent.$parent }
      deleteTriggerPayload: ->
        payload =
          scanner_ids: @selectedScanners.map((e) -> e.id)
        payload

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange()

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        filtersPayload = @formatFiltersPayload()
        @actions.fetchResource(null, @resourceKey, filtersPayload, { page: @pageNumber })
        @pageNumber += 1

      formatFiltersPayload: ->
        payload = {...@filters}

        timeWindows = payload.time_windows
        for field, timeWindow of timeWindows
          delete timeWindows[field] if not timeWindow

        payload

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @hiFilterChange()

export default VueOptions.vue settings
